<template>
  <el-button
    icon="el-icon-arrow-left"
    size="small"
    @click="backClick"
  >
    Назад
  </el-button>
</template>

<script>
export default {
  name: 'UiBackButton',
  props: {
    href: {
      type: String,
      required: true,
    },
  },
  methods: {
    backClick() {
      this.$inertia.visit(this.href);
    },
  },
};
</script>
